const data2 = [
    {
      title: "Impulsa tu cambio de carrera",
      background: "/assets/images/dojopy/profile_1.png",
    },
    {
      title: "Si eres principiante en programación	",
      background: "/assets/images/dojopy/profile_4.png",
    },
    {
      title: "Potencia tu CV con habilidades tech	",
      background: "/assets/images/dojopy/profile_2.png",
    },
    {
      title: "Emprende y lidera proyectos digitales	",
      background: "/assets/images/dojopy/profile_5.png",
    },
    {
      title: "Genera más ingresos con una profesión rentable",
      background: "/assets/images/dojopy/profile_3.png",
    },
  ];
  


export const dataUSA = [
  {
    title: "Boost your career change",
    background: "/assets/images/dojopy/profile_1.png",
  },
  {
    title: "If you're a programming beginner",
    background: "/assets/images/dojopy/profile_4.png",
  },
  {
    title: "Enhance your resume with tech skills",
    background: "/assets/images/dojopy/profile_2.png",
  },
  {
    title: "Start and lead digital projects",
    background: "/assets/images/dojopy/profile_5.png",
  },
  {
    title: "Earn more with a profitable profession",
    background: "/assets/images/dojopy/profile_3.png",
  },
];

  
  export default data2;